import { loadImportsHistory, loadImportsHistorySuccess } from './actions';
import { IntegrationViewState } from './types';
import {
  persistentReducedStream,
  reducer,
  streamReducer,
} from '@ardoq/rxbeach';
import {
  integrationRoute$,
  type IntegrationRoute,
} from './router/integrationRoute$';
import { ImportHistory } from '@ardoq/api-types/integrations';

const integrationRouteReducer = (
  currentState: IntegrationViewState,
  { id, path }: IntegrationRoute
): IntegrationViewState => ({
  ...currentState,
  integrationPath: path,
  selectedIntegrationId: id,
});
const handleIntegrationRoute = streamReducer(
  integrationRoute$,
  integrationRouteReducer
);

const loadImportsHistoryReducer = (currentState: IntegrationViewState) => ({
  ...currentState,
  isLoadingImports: true,
});
const handleImportsHistory = reducer(
  loadImportsHistory,
  loadImportsHistoryReducer
);

const loadImportsHistorySuccessReducer = (
  currentState: IntegrationViewState,
  { imports }: { readonly imports: ImportHistory[] }
) => ({
  ...currentState,
  imports,
  isLoadingImports: false,
});
const handleImportsHistorySuccess = reducer(
  loadImportsHistorySuccess,
  loadImportsHistorySuccessReducer
);

const reducers = [
  handleIntegrationRoute,
  handleImportsHistory,
  handleImportsHistorySuccess,
];

const defaultState = {
  selectedIntegrationId: null,
  integrationPath: null,
  isLoadingImports: true,
  imports: [],
};

const integrationViewState$ = persistentReducedStream<IntegrationViewState>(
  'integrationsViewState$',
  defaultState,
  reducers
);

export { integrationViewState$ };
